module.exports = __webpack_public_path__ + "images/ca2289dd33b355653f49756f025792b9a5eff8f9dd2d83bf757dfe7713ca0df2.svg";